/**
 * Retrieves the names of invalid fields from the provided form schema.
 *
 * Iterates through the `currentFormSchema` array, recursively checking each field
 * and its children (if present) using the `isValidFieldForFormData` helper.
 * Collects and returns the names of all fields that are considered invalid.
 *
 * @param {Object} params - The parameters object.
 * @param {Array<Object>} params.currentFormSchema - The schema representing the form structure.
 * @returns {Array<string>} An array of field names that are invalid for form data.
 */
import isValidFieldForFormData from './isValidFieldForFormData';

const getInValidPostFields = (
  { currentFormSchema },
  submitWithReadOnlyFields,
) => {
  let registeredFields = [];
  currentFormSchema.forEach(formItem => {
    if (formItem.children) {
      formItem.children.forEach(field => {
        if (field.children && field.children.length > 0) {
          field.children.forEach(childField => {
            if (
              !isValidFieldForFormData(childField, submitWithReadOnlyFields)
            ) {
              registeredFields = [...registeredFields, childField?.name];
            }
          });
        } else if (!isValidFieldForFormData(field, submitWithReadOnlyFields)) {
          registeredFields = [...registeredFields, field?.name];
        }
      });
    } else if (!isValidFieldForFormData(formItem, submitWithReadOnlyFields)) {
      registeredFields = [...registeredFields, formItem?.name];
    }
  });
  return registeredFields;
};

export default getInValidPostFields;
